module.exports = __webpack_public_path__ + "img/5.4852ce44.jpg";